import { motion, AnimatePresence } from "framer-motion";
import { ReactNode } from "react";
import { useLocation } from "react-router";

const moveVariants = {
  initial: { opacity: 0, x: -50 },
  animate: { opacity: 1, x: 0, transition: { duration: 0.5 } },
};

const PageWrapper = ({ 
  children, 
  onRouteChange = false, 
  isTransition = false,
}: { 
  children: ReactNode, 
  onRouteChange?: boolean, 
  isTransition?: boolean,
}) => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      {
        onRouteChange ? (
          <motion.div
            key={location.pathname} // Ensure animation triggers on route change
            initial="initial"
            animate="animate"
            variants={isTransition ? moveVariants : {}}
          >
            {children}
          </motion.div>
        ) : (
          <motion.div
            initial="initial"
            animate="animate"
            variants={isTransition ? moveVariants : {}}
          >
            {children}
          </motion.div>
        )
      }
    </AnimatePresence>
  );
};

export default PageWrapper